import MUIButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const CompactButton = styled(MUIButton)`
  borderRadius: 4px;
  height: 26px;
  text-transform: none;
  line-height: 1em;
  display: inline-block;
  padding: 3px 8px;
  font-size: 12px;

  span {
    white-space: nowrap;
  }
`;

export default CompactButton;
